if (!customElements.get('contact-country-region')) {
  class ContactCountryRegion extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.select = this.querySelector('[data-country-region-select]');
      if (!this.select) return;

      this.initialized = true;
      this.form = this.select.form;
      this.connectLocalizationForm();
      this.handleChange = this.onCountryChange.bind(this);
      this.handleReset = () => requestAnimationFrame(() => this.syncCountryCode());

      this.select.addEventListener('change', this.handleChange);
      this.form?.addEventListener('reset', this.handleReset);
      this.syncCountryCode();
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.select.removeEventListener('change', this.handleChange);
      this.form?.removeEventListener('reset', this.handleReset);
      this.initialized = false;
    }

    onCountryChange() {
      this.syncCountryCode();

      if (!this.localizationForm || !this.localizationInput) {
        this.connectLocalizationForm();
      }

      if (!this.localizationForm || !this.localizationInput) return;

      this.localizationInput.value = this.select.value;
      this.localizationForm.submit();
    }

    connectLocalizationForm() {
      this.localizationForm = document.getElementById(this.dataset.localizationFormId);
      this.localizationInput = this.localizationForm?.querySelector('[data-country-region-localization-input]');
    }

    syncCountryCode() {
      this.dataset.countryCode = this.select.value;
    }
  }

  customElements.define('contact-country-region', ContactCountryRegion);
}